<template>

  <div
    class="vpay__step"
    v-loading="loading"
  >

    <EditableBlock
      class="vpay__summary"
      :mode="userSummaryMode"
      :show-button="$store.getters.userIsLoggedIn"
    >
      <template slot="display">
        <el-row>
          <el-col
            v-for="(item, i) in userSummary"
            :span="item.width"
            :key="i"
          >
            <label
              class="vpay__summary-label"
              :class="$css(styles['vpay__summary-label'])"
            >{{ item.label }}</label>
            <p class="vpay__summary-item">{{ item.value }}</p>
          </el-col>
        </el-row>
      </template>
      <template slot="editable">
        <el-row>
          <el-col :span="12">
            <div
              class="vpay__input-container"
              style="padding-right: 6px"
            >
              <label>First Name</label>
              <input
                class="vpay__input vpay__input--small"
                type="text"
                v-model="$store.state.user.first_name"
              >
            </div>
          </el-col>
          <el-col :span="12">
            <div
              class="vpay__input-container"
              style="padding-left: 6px"
            >
              <label>Last Name</label>
              <input
                class="vpay__input vpay__input--small"
                type="text"
                v-model="$store.state.user.last_name"
              >
            </div>
          </el-col>
          <el-col :span="24">
            <div class="vpay__input-container">
              <label>Email Address</label>
              <input
                class="vpay__input vpay__input--small"
                type="text"
                v-model="$store.state.user.email"
              >
            </div>
          </el-col>
          <el-col :span="24">
            <div class="vpay__input-container">
              <label>Address (Optional)</label>
              <vue-google-autocomplete
                id="place"
                ref="location"
                classname="vpay__input vpay__input--small"
                placeholder=""
                :value="$store.getters.userAddressString"
                :country="['au']"
                @placechanged="onChangeAddress"
              ></vue-google-autocomplete>
            </div>
          </el-col>
        </el-row>
      </template>
    </EditableBlock>

    <EditableBlock
      class="vpay__summary"
      :show-editable-state="false"
      @event="onPaymentSummaryEvent"
    >
      <template slot="display">
        <el-row>
          <el-col
            v-for="(item, i) in paymentSummary"
            :span="12"
            :key="i"
          >
            <label
              class="vpay__summary-label"
              :class="$css(styles['vpay__summary-label'])"
            >{{ item.label }}</label>
            <p class="vpay__summary-item">{{ item.value }}</p>
          </el-col>
        </el-row>
      </template>
    </EditableBlock>

    <el-row>
      <el-col :span="24">
        <div style="padding: 12px 12px 0 12px">
          <label>Card Details</label>
          <div
            id="merchantWarriorPayframe"
            style="margin-top: -20px;"
          ></div>
        </div>
      </el-col>
    </el-row>

    <div class="vpay__input-container">
      <el-button
        class="vpay__next-button"
        type="success"
        :disabled="nextButtonDisabled"
        @click="onClickNext"
        round
      >{{ nextButtonLabel }}</el-button>
    </div>

  </div>

</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

import EditableBlock from "@/components/EditableBlock";

export default {
  name: "MerchantWarrior",

  components: { VueGoogleAutocomplete, EditableBlock },

  computed: {
    styles() {
      return this.$style({
        "vpay__summary-label": {
          color: this.$store.getters.brandColour
            ? this.$store.getters.brandColour
            : "inherit",
        },
      });
    },

    paymentSummary() {
      let type = this.$store.getters.frequency.type;
      let interval = this.$store.getters.frequency.interval;

      if (type === "recurring") {
        type = `${this.$options.filters.formatFrequencyType(
          type
        )} (${this.$options.filters.formatFrequencyInterval(interval)})`;
      } else {
        type = this.$options.filters.formatFrequencyType(type);
      }

      if (this.$store.getters.selectedCause.has_notes) {
        return [
          {
            label: "How much",
            value: this.$options.filters.formatAmount(
              this.$store.getters.amount
            ),
          },
          { label: "Towards", value: this.$store.getters.selectedCause.title },
          { label: "How often", value: type },
          {
            label: "Starting on",
            value: this.$options.filters.moment(
              this.$store.getters.frequency.startDate,
              "D MMMM YYYY"
            ),
          },
          {
            label: "Notes",
            value: this.$store.getters.notes ? this.$store.getters.notes : "-",
          },
        ];
      } else {
        return [
          {
            label: "How much",
            value: this.$options.filters.formatAmount(
              this.$store.getters.amount
            ),
          },
          { label: "Towards", value: this.$store.getters.selectedCause.title },
          { label: "How often", value: type },
          {
            label: "Starting on",
            value: this.$options.filters.moment(
              this.$store.getters.frequency.startDate,
              "D MMMM YYYY"
            ),
          },
        ];
      }
    },

    userSummary() {
      return [
        {
          width: 12,
          label: "Name",
          value: `${this.$store.getters.user.first_name} ${this.$store.getters.user.last_name}`,
        },
        { width: 12, label: "Email", value: this.$store.getters.user.email },
        {
          width: 24,
          label: "Address",
          value: this.$store.getters.userAddressString,
        },
      ];
    },

    userSummaryMode() {
      return this.$store.getters.userIsLoggedIn ? "display" : "edit";
    },

    userNeedsToCreateAccount() {
      return (
        this.$store.getters.frequency.type === "recurring" &&
        !this.$store.getters.userIsLoggedIn
      );
    },

    nextButtonDisabled() {
      return false;

      if (!this.payframeToken) {
        return true;
      }

      if (this.$store.getters.frequency.type === "recurring") {
        return this.$store.getters.userIsLoggedIn;
      }

      return false;
    },

    nextButtonLabel() {
      if (this.$store.getters.userIsLoggedIn) {
        return `Pay ${this.$options.filters.formatAmount(
          this.$store.getters.amount
        )} Now`;
      } else {
        if (this.userNeedsToCreateAccount) {
          return "Create Account";
        }
      }
      return `Pay ${this.$options.filters.formatAmount(
        this.$store.getters.amount
      )} as Guest`;
    },
  },

  methods: {
    onPaymentSummaryEvent(e) {
      if (e.name == "edit") {
        this.$store.commit("setPaymentStep", 1);
      }
    },

    processPayment() {
      // Payload.

      const payload = {
        customer: {
          user_id: this.$store.getters.user.id,
          first_name: this.$store.getters.user.first_name,
          last_name: this.$store.getters.user.last_name,
          full_name: `${this.$store.getters.user.first_name} ${this.$store.getters.user.last_name}`,
          email: this.$store.getters.user.email,
          mobile: this.$store.getters.mobileNumberValidated,
          address: this.$store.getters.address,
        },

        transaction: {
          description: this.$store.getters.selectedCause.title,
          amount: Number(this.$store.getters.amount).toFixed(2),
          currency: "AUD",
          frequency: { ...this.$store.getters.frequency },
          notes: this.$store.getters.notes,
        },

        payframe: {
          token: this.payframeToken,
          key: this.payframeKey,
        },

        card: {
          token: this.cardToken,
        },
      };

      // API request.

      this.axios
        .post("transactions", [payload], {
          headers: this.$store.getters.requestHeaders,
        })
        .then((r) => {
          if (r.data.success) {
            this.$store.commit("transactionResponse", r.data);
            this.$store.commit("incrementPaymentStep");
          } else {
            this.$message.warning(r.response.data.message);
          }
        })
        .catch(() => {
          this.$message.warning(
            "Uh oh... an unknown error occurred while processing your transaction. Please try again."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChangeAddress(address) {
      this.$store.commit("address", {
        street_1: `${address.street_number} ${address.route}`,
        city: address.locality,
        state: address.administrative_area_level_1,
        postcode: address.postal_code,
        country: address.country,
      });
    },

    onClickNext() {
      if (this.userNeedsToCreateAccount) {
        this.$store.commit("displayComponentName", "CreateAccount");
      } else {
        this.loading = true;

        if (this.payframeToken || this.cardToken) {
          this.processPayment();
        } else {
          this.payframe.submitPayframe();
        }
      }
    },
  },

  mounted() {
    /*
				Variables
			*/

    const payframeElementId = "merchantWarriorPayframe";

    const payframeAcceptedCards = "Visa, Mastercard";

    const payframeStyle = {
      backgroundColor: "white",
      textColor: "#333333",

      errorTextColor: "red",
      errorBorderColor: "red",

      width: "100%",

      cardTypeDisplay: "none",

      fieldHeight: "40px",
      border: "2px solid rgba(0, 0, 0, 0.1)",
      padding: "8px 12px",
      fontFamily: "Montserrat",
      fontSize: "16px",
      marginTop: "10px",
      marginBottom: "0px",

      placeholderStyle: {
        color: "lightgray",
        fontSize: "16px",
      },
    };

    let payframeMethod = "getPayframeToken";

    if (this.$store.getters.frequency.type === "recurring") {
      payframeMethod = "addCard";
    }

    /*
				Locate Payframe Constructor
			*/

    let payframeConstructor;

    if ("payframe" in window) {
      payframeConstructor = window.payframe;
    } else if ("payframe" in window.parent) {
      payframeConstructor = window.parent.payframe;
    }

    /*
				Instantiate Payframe
			*/

    if (
      this.$store.getters.provider.settings.merchant_uuid &&
      this.$store.getters.provider.settings.merchant_api_key
    ) {
      this.payframe = new payframeConstructor(
        this.$store.getters.provider.settings.merchant_uuid,
        this.$store.getters.provider.settings.merchant_api_key,
        payframeElementId,
        this.$store.getters.provider.api_urls.payframe_source,
        this.$store.getters.provider.api_urls.payframe,
        payframeStyle,
        payframeAcceptedCards,
        payframeMethod
      );

      this.payframe.mwCallback = (tokenStatus, payframeToken, payframeKey) => {
        const method = this.payframe.method;
        const success = this.payframe.responseCode == 0;

        if (success) {
          // Store tokens / keys.

          if (method === "addCard") {
            this.cardToken = this.payframe.cardID;
          } else {
            this.payframeToken = this.payframe.payframeToken;
            this.payframeKey = this.payframe.payframeKey;
          }

          // Process the payment.

          this.processPayment();
        } else {
          this.loading = false;

          this.$message.warning(
            "Please fill in all of the required fields before paying."
          );

          console.log("Failed to get payframeToken");
          console.log(this.payframe.responseCode);
          console.log(this.payframe.responseMessage);
        }
      };

      this.payframe.deploy();
    }
  },

  data() {
    return {
      firstName: this.$store.getters.user.first_name,
      lastName: this.$store.getters.user.last_name,
      emailAddress: this.$store.getters.user.email,

      payframe: null,

      cardToken: null,

      payframeToken: null,
      payframeKey: null,

      loading: false,
    };
  },
};
</script>

<style>
</style>
